<template>
    <div class="getExif">
      <div class='container'>
        <div class='row text-center'>
          <div class='col-md-12'>
            <div class="btn btn-success" style="margin:5px;" @click="DoClick">选择图片</div>
            <input type="file" accept="image/*" style="display:none;" @change="DoChange($event)" ref="fileInput">
            <br>
            <img src="" alt="" ref="previewImage" style="max-width:150px">
            <br>
            <p v-html="outMsg"></p>
            <div>
              <div class="btn btn-success" style="margin:5px;" @click="DoCompressPhoto()">压缩图片</div>
              <br>
              <div class="btn btn-success" style="margin:5px;" @click="DoRotoPhoto()">旋转图片</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import EXIF from 'exif-js'; 
  export default {
    name: 'GetExif',
    data() {
      return {
        file:null,
        phtotsize:100/0.8,
        imgRotate:0,
        outMsg:""
      }
    },
    methods:{
        DoClick(){
            this.$refs.fileInput.click();
        },
        DoChange(e)
        {
            var that = this;
            that.file = e.target.files[0];
            var reader = new FileReader();
            reader.onload = function(event) {
                var img = new Image();
                img.onload = function() {
                    that.getImgExif(img).then(data => {
                        if (data) {
                          that.outMsg = '照片方向:' + data.Orientation + '<br>';
                            // 使用for...in循环遍历对象的所有属性  
                            for (let key in data) {
                                console.log(key + ": " + data[key]);
                                that.outMsg += '<br>' + key + ": " + data[key];
                            }

                        } else {
                          that.outMsg = '未找到照片方向信息.';
                            console.log('No EXIF Orientation found.');
                        }

                    });
                };
                img.src = event.target.result; // 设置img元素的src为FileReader读取的结果
                that.phtotsize = 100/0.8;
                that.imgRotate = 0;
                that.$refs.previewImage.src=event.target.result;
            };
            reader.readAsDataURL(that.file );
        },
        getImgExif(img) {
            return new Promise(resolve => {
              EXIF.getData(img, function() {
                    const data = EXIF.getAllTags(img)
                    console.log(data);
                    if (data.Orientation!=null) {
                        resolve(data)
                    }
                    resolve(null)
                })
            })
        },
        //imgRotate旋转角度 0 1 2 3
        DoRotoPhoto() {
          var that=this;
          that.imgRotate = (that.imgRotate + 1) % 4;
          that.DoCompressPhoto();
        },
        //压缩后的尺寸长：phtotsize*4  宽：phtotsize*3 
        DoCompressPhoto() {    
          var that=this;       
          that.phtotsize = that.phtotsize*0.8;
            const img = new Image();
            img.src = that.$refs.previewImage.src;
            img.onload = function () {
                const cvs = document.createElement('canvas');
                var ctx = cvs.getContext('2d');
                ctx.imageSmoothingEnabled = true;
                var maxW, maxH,left = 0, top = 0, imgHeight = 0, imgWidth = 0;
                //如果图片横向
                if (img.height < img.width) {
                    maxW = 4 * that.phtotsize;
                    maxH = 3 * that.phtotsize;
                    if (img.width * 3 > img.height * 4) //图片横向太长
                    {
                        imgHeight = img.height;
                        imgWidth = 4 * imgHeight / 3;
                        left = (img.width - imgWidth) / 2;
                    }
                    else //图片纵向太长
                    {
                        imgWidth = img.width;
                        imgHeight = 3 * imgWidth / 4;
                        top = (img.height - imgHeight) / 2;
                    }
                }
                //如果图片纵向
                else {
                    maxH = 4 * that.phtotsize;
                    maxW = 3 * that.phtotsize;
                    if (img.height * 3 > img.width * 4) //图片纵向太长
                    {
                        imgWidth = img.width;
                        imgHeight = 4 * imgWidth / 3;
                        top = (img.height - imgHeight) / 2;
                    }
                    else //图片横向太长
                    {
                        imgHeight = img.height;
                        imgWidth = 3 * imgHeight / 4;
                        left = (img.width - imgWidth) / 2;
                    }
                }
                

                //旋转角度以弧度值为参数  
                var degree = that.imgRotate * 90 * Math.PI / 180;
                switch (that.imgRotate) {
                    case 0:
                        cvs.width = maxW;
                        cvs.height = maxH;
                        ctx.drawImage(img, left, top, imgWidth, imgHeight, 0, 0, cvs.width, cvs.height);
                        break;
                    case 1:
                        cvs.width = maxH;
                        cvs.height = maxW;
                        ctx.rotate(degree);
                        ctx.drawImage(img, left, top, imgWidth, imgHeight, 0, -cvs.width, cvs.height, cvs.width);
                        break;
                    case 2:
                        cvs.width = maxW;
                        cvs.height = maxH;
                        ctx.rotate(degree);
                        ctx.drawImage(img, left, top, imgWidth, imgHeight, -cvs.width, -cvs.height, cvs.width, cvs.height);
                        break;
                    case 3:
                        cvs.width = maxH;
                        cvs.height = maxW;
                        ctx.rotate(degree);
                        ctx.drawImage(img, left, top, imgWidth, imgHeight, -cvs.height, 0, cvs.height, cvs.width);
                        break;
                }
                try {
                  var photoUrl = cvs.toDataURL('image/jpg', 0.8);
                  var photo = that.dataURLtoFile(photoUrl, "photo.jpg");
                  let url = window.URL.createObjectURL(photo); //表示一个指定的file对象或Blob对象
                  console.log(url, "看一下这是啥")
                  let a = document.createElement("a");
                  document.body.appendChild(a);
                  a.href = url;
                  a.download = 'photo.jpg'; //命名下载名称
                  a.click(); //点击触发下载  
                  window.URL.revokeObjectURL(url); //下载完成进行释放
                  console.log(photo);
                  that.outMsg = '压缩照片完成，大小:'+(photo.size/1024).toFixed(2)+'kb';
                }
                catch (err) {
                  console.log(err);
                  that.outMsg = '压缩照片出错.';
                }
            }
        },
        dataURLtoFile(dataurl, filename) {
            //转成blob
            function dataURLtoBlob(toDataURL) {
                var arr = toDataURL.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }

                var blob = null;

                // 解决低版本浏览器没有new Blob()问题
                try {
                    blob = new Blob([u8arr], { type: mime });
                } catch (e) {
                    var BlobBuilder = window.BlobBuilder = (
                        window.BlobBuilder ||
                        window.WebKitBlobBuilder ||
                        window.MozBlobBuilder ||
                        window.MSBlobBuilder
                    );

                    if (e.name === "TypeError" && BlobBuilder) {
                        var builder = new BlobBuilder();
                        builder.append(u8arr);
                        blob = builder.getBlob(mime);
                    }
                }

                return blob;
            }
            //转成file
            function blobToFile(Blob) {
                Blob.lastModifiedDate = new Date();
                Blob.name = filename;
                return Blob;
            }

            // 调用如下
            let bold = dataURLtoBlob(dataurl);
            let file = blobToFile(bold);

            // 上传file就可以了
            return file;
          }
    },
    computed:{
      
    },
    mounted()
    {
        
    }
  }
  </script>